/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, Icon } from "components/Component";
import { Modal, ModalBody, Spinner } from "reactstrap";
import { serviceGetAllCampaigns } from "services/campaign";

const ChatModalFilterCampaign = (props) => {
  const {
    cookies,
    isModalCampaignFilterOpen,
    setIsModalCampaignFilterOpen,
    setFilterCampaign,
    filterCampaign
  } = props;

  const [search, setSearch] = useState("");
  const [campaignList, setCampaignList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredCampaignList, setFilteredCampaignList] = useState([]);
  const [selectedFilterItem, setSelectedFilterItem] = useState([]);

  const handleCheckboxClicked = (e, campaign) => {
    if (e.target.checked) {
      setSelectedFilterItem([...selectedFilterItem, campaign.id]);
    } else {
      const newFilter = selectedFilterItem.filter((id) => id !== campaign.id);
      setSelectedFilterItem(newFilter);
    }
  };

  const refreshCampaignsList = async () => {
    setLoading(true);
    try {
      // Call service with status='ACTIVE' to get only active campaigns
      const response = await serviceGetAllCampaigns(cookies.SIDikey, 'ACTIVE');

      if (Array.isArray(response)) {
        // Mark campaigns that are already selected
        const campaignsWithCheck = response.map(campaign => ({
          ...campaign,
          isChecked: filterCampaign.includes(campaign.id)
        }));
        setCampaignList(campaignsWithCheck);
        setFilteredCampaignList(campaignsWithCheck);
      }
    } catch (error) {
      console.error("Error fetching active campaigns:", error);
    } finally {
      setLoading(false);
    }
  };

  const chooseFilterCampaign = () => {
    setFilterCampaign([...new Set(selectedFilterItem)]);
    setIsModalCampaignFilterOpen(false);
  };

  // Load campaigns when modal opens
  useEffect(() => {
    if (isModalCampaignFilterOpen === true) {
      refreshCampaignsList();
      setSelectedFilterItem(filterCampaign); // Set dari filter yang sudah ada
    }
  }, [isModalCampaignFilterOpen]);

  // Filter campaigns by search
  useEffect(() => {
    if (search !== "") {
      const filtered = campaignList.filter((campaign) =>
        campaign.name?.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredCampaignList(filtered);
    } else {
      setFilteredCampaignList(campaignList);
    }
  }, [search, campaignList]);

  return (
    <Modal
      isOpen={isModalCampaignFilterOpen}
      backdrop="static"
      keyboard={false}
      toggle={() => setIsModalCampaignFilterOpen(false)}
      className="modal-dialog-centered"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsModalCampaignFilterOpen(false);
            setSearch("");
            setSelectedFilterItem(filterCampaign);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="mb-4">
          <h5>Filter by Campaign</h5>
          <p className="text-muted small mb-0">Showing active campaigns only</p>
        </div>
        <div className="form-control-wrap">
          <div className="form-icon form-icon-left">
            <Icon name="search"></Icon>
          </div>
          <input
            type="text"
            className="form-round form-control"
            placeholder="Search Campaign Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div
          style={{ maxHeight: 350, overflowY: "auto" }}
          className="mt-2 filter"
        >
          {loading ? (
            <div className="d-flex justify-content-center align-item-stretch py-4">
              <Spinner animation="border" role="status" color="blue" />
            </div>
          ) : filteredCampaignList.length > 0 ? (
            filteredCampaignList.map((campaign) => (
              <div
                className="card-inner-md"
                key={campaign.id}
                style={{ cursor: "pointer" }}
              >
                <div className="user-card">
                  <input
                    type="checkbox"
                    name="campaign"
                    onChange={(e) => handleCheckboxClicked(e, campaign)}
                    className="mr-2"
                    checked={selectedFilterItem.includes(campaign.id)}
                  />
                  <span className="text-dark font-weight-medium">
                    {campaign.name}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4 text-muted">
              {search ? "No campaigns found" : "No active campaigns available"}
            </div>
          )}
        </div>
        <div className="d-flex justify-content-around mt-3">
          <Button
            color="primary"
            onClick={() => chooseFilterCampaign()}
            className="col-6"
            style={{ width: "100%", justifyContent: "center" }}
          >
            Apply Filter
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ChatModalFilterCampaign;
